import React, { useState, useCallback } from 'react';

function writeToClipboard(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).catch(() => {});
    return;
  }
  // Régi böngészők / nem biztonságos kontextus (http)
  const el = document.createElement('textarea');
  el.value = text;
  el.style.position = 'fixed';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  try { document.execCommand('copy'); } catch { /* nincs mit tenni */ }
  document.body.removeChild(el);
}

/**
 * Egységes másoló gomb. Kattintás után 2 másodpercig visszajelzést mutat.
 *
 * `variant="icon"`   — csak ikon (szűk helyre, pl. táblázat cellába)
 * `variant="text"`   — ikon + felirat
 * `variant="button"` — teljes üveg-gomb ikonnal és felirattal
 */
export default function CopyButton({
  value,
  label = 'Copy',
  copiedLabel = 'Copied',
  variant = 'text',
  className = '',
  title,
}) {
  const [copied, setCopied] = useState(false);

  const onClick = useCallback((e) => {
    e.stopPropagation();
    if (value == null) return;
    writeToClipboard(String(value));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [value]);

  const icon = copied ? (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
         strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5">
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
    </svg>
  );

  // Teljes gomb (üveg), pl. az ajánlói kód mellett.
  if (variant === 'button') {
    return (
      <button type="button" onClick={onClick} title={title} className={`btn-glass ${className}`}>
        {icon}
        {copied ? copiedLabel : label}
      </button>
    );
  }

  if (variant === 'icon') {
    return (
      <button
        type="button"
        onClick={onClick}
        title={title || label}
        aria-label={title || label}
        className={`inline-flex items-center justify-center w-7 h-7 rounded-lg flex-shrink-0
                    border border-transparent transition-colors duration-150 ${
          copied
            ? 'text-ok bg-ok/10 border-ok/20'
            : 'text-gray-500 hover:text-gray-50 hover:bg-white/[0.06]'
        } ${className}`}
      >
        {icon}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className={`inline-flex items-center gap-1.5 text-xs font-medium px-2 py-1 rounded-lg
                  flex-shrink-0 transition-colors duration-150 ${
        copied
          ? 'text-ok bg-ok/10'
          : 'text-brand-400 hover:text-brand-300 hover:bg-white/[0.06]'
      } ${className}`}
    >
      {icon}
      {copied ? copiedLabel : label}
    </button>
  );
}
